import React from "react";
import { Text } from "@mantine/core";
import { TimezoneUtils } from "../../utils/timezoneUtils";

export interface TimezoneIndicatorProps {
    /** Whether to show the full timezone name or just abbreviation */
    showFullName?: boolean;
    /** Text size */
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    /** Additional styling */
    style?: React.CSSProperties;
}

/**
 * A small component that displays the current user's timezone
 * Used in charts and other components to indicate timezone context
 */
export const TimezoneIndicator: React.FC<TimezoneIndicatorProps> = ({ showFullName = false, size = "xs", style = {} }) => {
    const timezone = TimezoneUtils.getUserTimezone();
    const timezoneAbbr = TimezoneUtils.getTimezoneAbbreviation();

    const displayText = showFullName ? `${timezone} (${timezoneAbbr})` : timezoneAbbr;

    return (
        <Text
            size={size}
            c="dimmed"
            style={{
                opacity: 0.7,
                fontStyle: "italic",
                ...style
            }}
        >
            {displayText}
        </Text>
    );
};
